import React from 'react';
import { motion } from 'framer-motion';
export function ProblemSection() {
  return <section className="py-12 px-4 bg-matrix-bg relative" data-id="element-298">
      <div className="max-w-3xl mx-auto" data-id="element-299">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-300">
          <h2 className="text-3xl md:text-4xl font-bold text-matrix-orange mb-2" data-id="element-301">
            Esto es lo que está pasando
          </h2>
          <p className="text-matrix-muted mb-8 italic" data-id="element-302">(sin dramatizar)</p>

          <div className="space-y-6 text-lg md:text-xl text-matrix-text/90 leading-relaxed" data-id="element-303">
            <p data-id="element-304">No estás roto.</p>
            <p data-id="element-305">
              Estás{' '}
              <span className="text-matrix-red font-semibold" data-id="element-306">entrenado</span>.
            </p>
            <p data-id="element-307">
              Entrenado a{' '}
              <span className="text-matrix-red font-semibold" data-id="element-308">
                urgencia, comparación y distracción
              </span>
              .
            </p>
            <p data-id="element-309">Por eso el silencio se siente raro.</p>
            <p data-id="element-310">Por eso el enfoque se siente pesado.</p>
            <p data-id="element-311">Por eso la calma se siente "aburrida".</p>
          </div>

          <div className="mt-10 pl-6 border-l-4 border-matrix-orange py-2 bg-matrix-surface/50 rounded-r-lg" data-id="element-312">
            <p className="text-xl md:text-2xl font-medium text-matrix-text" data-id="element-313">
              La Matrix moderna no necesita cadenas.
              <br data-id="element-314" />
              <span className="text-matrix-primary" data-id="element-315">
                Solo necesita tu ausencia.
              </span>
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}